import React from 'react'

function Iframe({ source }) {
  return (
    <iframe
      src={source}
      width="100%"
      style={{
        border: 'none',
        minHeight: '1300px',
        height: '100vh'
      }}
    ></iframe>
  )
}

export default Iframe
